import React from "react";
import isotipoHabitia from "../../../assets/isotipo.png";

// PAGINA 6 — Capitulo VI (Administrador)
export default function AdministradorPage({ pagNum, pagTotal, capRomanoMap }) {
  const secNum = String(pagNum - 2).padStart(2, "0");
  return (
    <section className="page">
      <div className="page-pad">
        <span className="sec-tag">{secNum} · Administración</span>
        <h2 className="big">Del <em>Administrador.</em></h2>
        <p className="lead">
          Conforme a la Ley N° 10.751 de Propiedad Horizontal, el Administrador asume la operación cotidiana bajo el control de la Comisión.
        </p>

        <div className="art">
          <div className="art-head">
            <div className="art-num">Capítulo {capRomanoMap.administrador}</div>
            <h3 className="art-title">Administrador</h3>
          </div>
          <h4 className="sub-h">Competencia</h4>
          <ol className="rules">
            <li><span className="m">a</span><span>Facilitar a la Comisión toda información y documentación requerida.</span></li>
            <li><span className="m">b</span><span>Efectuar rendiciones de cuentas; anualmente sometidas a la Asamblea.</span></li>
            <li><span className="m">c</span><span>Hacer cumplir las disposiciones del presente Reglamento.</span></li>
            <li><span className="m">d</span><span>Llevar <b>Libro Registro de Propietarios</b> actualizado.</span></li>
          </ol>
          <h4 className="sub-h">Cometidos</h4>
          <ol className="rules">
            <li><span className="m">a</span><span>Contratar personal de limpieza, seguridad, mantenimiento, jardinería y portería.</span></li>
            <li><span className="m">b</span><span>Dirigir al personal: instruir, controlar, advertir, suspender y despedir.</span></li>
            <li><span className="m">c</span><span>Liquidar sueldos y abonar salarios y cargas sociales en tiempo y forma.</span></li>
            <li><span className="m">d</span><span>Contratar service de ascensores, CCTV, limpieza, seguridad y póliza de incendio.</span></li>
            <li><span className="m">e</span><span>Contratar mantenimiento y supervisar el estado general del edificio.</span></li>
            <li><span className="m">f</span><span>Realizar trámites ante BSE, BPS, Intendencia, OSE y demás organismos.</span></li>
            <li><span className="m">g</span><span>Presentar <b>mensualmente</b> liquidación detallada de ingresos y egresos.</span></li>
            <li><span className="m">h</span><span>Hacer ejecutar a propietarios morosos; cobrar multas e intereses.</span></li>
            <li><span className="m">i</span><span>Representar al edificio en juicio en causas de administración.</span></li>
            <li><span className="m">j</span><span>Gestionar cobro de gastos comunes y pago de consumos comunes.</span></li>
          </ol>
        </div>
      </div>
      <div className="pfooter">
        <div className="br"><img src={isotipoHabitia} alt="" />habitia · Reglamento Interno</div>
        <div className="pn">{String(pagNum).padStart(2, "0")} / {String(pagTotal).padStart(2, "0")}</div>
      </div>
    </section>
  );
}
